const YEAR_MONTH_PATTERN = /^(\d{1,2})\/(\d{4})$/;
const YEAR_MONTH_QUERY_PATTERN = /^(\d{4})-(\d{2})$/;

const MONTH_NAMES = Object.freeze([
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]);

export const parseYearMonthKey = (key) => {
  const match = typeof key === 'string' && key.match(YEAR_MONTH_PATTERN);
  if (!match) return null;

  const month = Number(match[1]);
  const year = Number(match[2]);
  if (month < 1 || month > 12 || year < 1) return null;

  return { month, year };
};

export const toYearMonthParam = (key) => {
  const parsed = parseYearMonthKey(key);
  if (!parsed) return null;

  return `${parsed.year}-${String(parsed.month).padStart(2, '0')}`;
};

export const fromYearMonthParam = (value) => {
  const match = typeof value === 'string' && value.match(YEAR_MONTH_QUERY_PATTERN);
  if (!match) return null;

  const year = Number(match[1]);
  const month = Number(match[2]);
  if (year < 1 || month < 1 || month > 12) return null;

  return `${month}/${year}`;
};

export const compareYearMonthKeys = (leftKey, rightKey) => {
  const left = parseYearMonthKey(leftKey);
  const right = parseYearMonthKey(rightKey);
  if (!left || !right) return null;

  const leftIndex = left.year * 12 + left.month;
  const rightIndex = right.year * 12 + right.month;
  return Math.sign(leftIndex - rightIndex);
};
export const shiftYearMonthKey = (key, offset) => {
  const parsed = parseYearMonthKey(key);
  if (!parsed || !Number.isSafeInteger(offset)) return null;

  const absoluteMonth = parsed.year * 12 + parsed.month - 1 + offset;
  const year = Math.floor(absoluteMonth / 12);
  const month = ((absoluteMonth % 12) + 12) % 12 + 1;

  return year >= 1 ? `${month}/${year}` : null;
};

export const getCurrentYearMonthKey = (now = new Date()) => {
  if (!(now instanceof Date) || Number.isNaN(now.getTime())) return null;
  return `${now.getMonth() + 1}/${now.getFullYear()}`;
};

export const formatYearMonthLabel = (key, { includeYear = true } = {}) => {
  const parsed = parseYearMonthKey(key);
  if (!parsed) return null;

  const monthName = MONTH_NAMES[parsed.month - 1];
  return includeYear ? `${monthName} de ${parsed.year}` : monthName;
};
